// src/layout/AuthenticatedLayout.jsx
import React from "react";
import NavBar from "../components/NavBar";

const AuthenticatedLayout = ({ title, children, loading }) => {
	return (
		<div className="has-background-light pb-5" style={{ minHeight: "100%" }}>
			<NavBar isAuthenticated={true} />

			<header>
				<p className="title is-3 has-text-centered my-4">{loading ? "" : title.toUpperCase()}</p>
			</header>
			<main className="container is-max-widescreen box">{children}</main>
		</div>
	);
};

export default AuthenticatedLayout;
